<ul class="MyMoeinList">

  <li *ngFor="let item of DataList_Peyvast">

    <div *ngIf="canOpenPeyvast">
        <a target="_blank" *ngIf="item.letterType=='رسید امانت'"
        [routerLink]="['/LetterRequestCustomerPreOrder',{id:item.id}]"><i class="fa fa-file"></i> Letter Number <b>{{item.code}}</b> ({{item.letterType === 'رسید امانت' ? 'Custody Receipt' : item.letterType === 'نامه وارده' ? 'Incoming Letter' : item.letterType === 'نامه صادره' ? 'Outgoing Letter' : item.letterType === 'درخواست کالیبراسیون' ? 'Calibration Request' : item.letterType}}) </a>
      <a target="_blank" *ngIf="item.letterType=='نامه وارده'"
        [routerLink]="['/LetterRequestCustomerDraftForm',{id:item.id}]"><i class="fa fa-file"></i> Letter Number <b>{{item.code}}</b> ({{item.letterType === 'رسید امانت' ? 'Custody Receipt' : item.letterType === 'نامه وارده' ? 'Incoming Letter' : item.letterType === 'نامه صادره' ? 'Outgoing Letter' : item.letterType === 'درخواست کالیبراسیون' ? 'Calibration Request' : item.letterType}}) </a>
      <a target="_blank" *ngIf="item.letterType=='نامه صادره'"
        [routerLink]="['/LetterRequestCustomerForm',{id:item.id}]"><i class="fa fa-file"></i> Letter Number <b>{{item.code}}</b> ({{item.letterType === 'رسید امانت' ? 'Custody Receipt' : item.letterType === 'نامه وارده' ? 'Incoming Letter' : item.letterType === 'نامه صادره' ? 'Outgoing Letter' : item.letterType === 'درخواست کالیبراسیون' ? 'Calibration Request' : item.letterType}}) </a>
      <a target="_blank" *ngIf="item.letterType=='درخواست کالیبراسیون'"
        [routerLink]="['/LetterRequestCustomerCalibration',{id:item.id}]"><i class="fa fa-file"></i> Letter Number <b>{{item.code}}</b> ({{item.letterType === 'رسید امانت' ? 'Custody Receipt' : item.letterType === 'نامه وارده' ? 'Incoming Letter' : item.letterType === 'نامه صادره' ? 'Outgoing Letter' : item.letterType === 'درخواست کالیبراسیون' ? 'Calibration Request' : item.letterType}}) </a>

    </div>
    <div  *ngIf="!canOpenPeyvast">
        <a  *ngIf="item.letterType=='رسید امانت'"  ><i class="fa fa-file"></i> Letter Number <b>{{item.code}}</b> (Custody Receipt) </a>
        <a  *ngIf="item.letterType=='نامه وارده'"><i class="fa fa-file"></i> Letter Number <b>{{item.code}}</b> (Incoming Letter) </a>
        <a  *ngIf="item.letterType=='نامه صادره'"><i class="fa fa-file"></i> Letter Number <b>{{item.code}}</b> (Outgoing Letter) </a>
        <a  *ngIf="item.letterType=='درخواست کالیبراسیون'"><i class="fa fa-file"></i> Letter Number <b>{{item.code}}</b> (Calibration Request) </a>

    </div>

    <div class="subMoeinDiv">

      <div *ngIf="item.letterType!='رسید امانت'">
        <div class="subMoeinDivDetail">
          <p> Last Sender User : {{item.lastSender}} </p>
          <p> Last Recipient User : {{item.lastGiver}} </p>
          <p> Last Status: {{item.lastSection}} </p>
          <p> Last Message: {{item.lastOrder}} </p>
          <p> {{item.persianDate}} </p>
        </div>
        <div style="clear:both"></div>
        <p class="subMoeinDsc"> Letter Subject : {{item.subject_name}} </p>
        <p class="subMoeinDsc"> Recipient Name : {{item.giver_name}} </p>
        <p class="subMoeinDsc"> Recipient Position : {{item.giver_semat}} </p>
        <p class="subMoeinFooter">{{item.persianDate}}</p>
      </div>
      <div *ngIf="item.letterType=='رسید امانت'">
        <div class="subMoeinDivDetail">
          <p> Registered By : {{item.lastSender}} </p>
          <p> Status: {{item.lastSection}} </p>
          <p> Message: {{item.lastOrder}} </p>
          <p> {{item.persianDate}} </p>
        </div>
        <div style="clear:both"></div>
      </div>


      <a target="_blank" *ngIf="item.letterType=='رسید امانت'"
        [routerLink]="['/LetterRequestCustomerPreOrder',{id:item.id}]"><i class="fa fa-eye"></i> View </a>
      <a target="_blank" *ngIf="item.letterType=='نامه وارده'"
        [routerLink]="['/LetterRequestCustomerDraftForm',{id:item.id}]"><i class="fa fa-eye"></i> View </a>
      <a target="_blank" *ngIf="item.letterType=='نامه صادره'"
        [routerLink]="['/LetterRequestCustomerForm',{id:item.id}]"><i class="fa fa-eye"></i> View </a>
      <a target="_blank" *ngIf="item.letterType=='درخواست کالیبراسیون'"
        [routerLink]="['/LetterRequestCustomerCalibration',{id:item.id}]"><i class="fa fa-eye"></i> View </a>

    </div>
    <app-LetterRequestCustomerPeyvast [canOpenPeyvast]="canOpenPeyvast" [DataList_Peyvast]="item.detail"></app-LetterRequestCustomerPeyvast>
  </li>
</ul>
